import { Balance, FinanceBalanceState } from '@/api/models/finance'
import { SwiperOption } from '@/components/shared/types-selector/TypesSelector.types'

export const getBalancePremiseText = (
  balance: Balance,
  selectedPremise?: SwiperOption
) => {
  if (balance.debtSum !== 0) {
    return balance.debtSum < 0
      ? `Аванс за ${selectedPremise?.title || 'все помещения'}`
      : `К оплате за ${selectedPremise?.title || 'все помещения'}`
  }

  switch (balance.state) {
    case FinanceBalanceState.NoInvoices: {
      return 'Счета не выставлены'
    }
    case FinanceBalanceState.AllPaid: {
      return selectedPremise ? 'Счета оплачены' : 'Все счета оплачены'
    }
  }
}
